import { put, call, select } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';

import * as Api from 'api';
import * as Actions from 'actions';
import * as ActionTypes from 'constants';

/***************************** Selectors ************************************/

export const getPlans = state => (state.plans);

/***************************** Subroutines ************************************/

function * fetchPlans({ payload: filters }) {
  try {
    const plans_list = yield call(Api.fetchPlans, filters || {});
    yield put(Actions.fetchPlansSuccess(plans_list.results));
  }
  catch(ex) {
    yield call(eventFailed, { payload: ex });
  }
}
function * createPlan({ payload: plan }) {
  try {
    yield put(Actions.toggleRequestingCreatePlan(true));
    const new_plan = yield call(Api.createPlan, plan);
    yield put(Actions.createNewPlanSuccess(new_plan));
    yield put(Actions.push('/sales-site/plans'));
  }
  catch(ex) {
    yield put(Actions.toggleRequestingCreatePlan(false));
    yield call(eventFailed, { payload: ex });
  }
}

function * updatePlan({ payload: plan }) {
  try {
    yield put(Actions.toggleRequestingUpdatePlan(true));
    const updated_plan = yield call(Api.updatePlan, plan);
    yield put(Actions.updatePlanSuccess(updated_plan));
    yield put(Actions.push('/sales-site/plans'));
  }
  catch(ex) {
    yield put(Actions.toggleRequestingCreatePlan(false));
    yield call(eventFailed, { payload: ex });
  }
}

function * initUpdatePlan({ payload: plan }) {
  yield put(Actions.push('/sales-site/plans/update'));
}

function * removePlan({ payload: plan_id }) {
  try {
    yield put(Actions.toggleRemovingPlan(true));
    yield call(Api.removePlan, plan_id);
    yield put(Actions.removePlanSuccess(plan_id));
  }
  catch(ex) {
    yield put(Actions.toggleRemovingPlan(false));
    yield call(eventFailed, { payload: ex });
  }
}

function * eventFailed({ payload, notify }) {
  console.log(payload);
  if(notify !== false) {
    yield put(Actions.notify({ message: payload.message || payload }));
  }
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function* plansWatcher() {
  yield* [
    takeEvery(ActionTypes.REQUEST_FETCH_PLANS, fetchPlans),
    takeEvery(ActionTypes.REQUEST_CREATE_PLAN, createPlan),
    takeEvery(ActionTypes.INIT_UPDATE_PLAN, initUpdatePlan),
    takeEvery(ActionTypes.REQUEST_UPDATE_PLAN, updatePlan),
    takeEvery(ActionTypes.REQUEST_REMOVE_PLAN, removePlan)
  ]
}



// WEBPACK FOOTER //
// ./src/common/sagas/plans.js